export const accessToken = 'accessToken';
export const refreshToken = 'refreshToken';
export const TOKEN_STORE_KEY = 'TOKEN_STORE_KEY';
export const T_TOKEN_STORE_KEY = "T_TOKEN_STORE_KEY";